/*
 * @Author: mayqiyue
 * @Date: 2018-11-16 10:39:32
 * @Last Modified by: mayqiyue
 * @Last Modified time: 2019-03-06 18:24:03
 */

import { store } from "@/main";
import * as types from "@/store/constants/setting_types";
import { boughtVip } from "@/utils/general_utils";

const VipOfferUtils: any = {
  /**
   * 拿到一个月的offer
   */
  getVipOneMonthOffer: () => {
    const serviceList = store.getters[types.GETTER_SERVICE_OFFERS];
    return serviceList && serviceList[0];
  },
  /**
   *
   * 判断购买该 service 是否会有额外赠送的月份, 默认为0
   */
  monthsBonus: (service: any) => {
    if (boughtVip()) {
      return 0;
    }
    if (!service) {
      return 0;
    }
    if (!service.hasOwnProperty("first_bonus")) {
      return 0;
    }
    if (!Array.isArray(service.first_bonus)) {
      return 0;
    }

    let periodDays = 0;

    service.first_bonus.forEach((dict: any) => {
      if (dict.hasOwnProperty("bonus") && Array.isArray(dict.bonus)) {
        dict.bonus.forEach((item: any) => {
          if (item.period_day && item.type) {
            if (item.type === "vip") {
              periodDays += item.period_day;
            }
          }
        });
      }
    });

    return Math.floor(periodDays / 30);
  },
  /**
   * 判断一个 service 是不是自动续订类型
   */
  isAutoRenew: (service: any) => {
    console.log("isAutoRenew", service);
    if (!service) {
      return false;
    }
    if (service.hasOwnProperty("is_no_auto_renew")) {
      return service.is_no_auto_renew === false;
    }
    if (
      service.hasOwnProperty("pay_source") &&
      service.pay_source === "paypal"
    ) {
      return true;
    }
  },
  /**
   * 判断购买该 service 是否会有金币奖励, 默认为 0
   */
  coinsBonus: (service: any) =>
    boughtVip()
      ? VipOfferUtils.renewCoinBonus(service)
      : VipOfferUtils.dailyCoinsReward(service),
  /**
   * 续订vip 金币奖励
   */
  renewCoinBonus: (service: any) => {
    if (service === undefined) {
      return 0;
    }
    const coins: number = service.hasOwnProperty("bonus")
      ? service.bonus.coin
      : 0;
    return coins;
  },

  /**
   *  首次购买的金币奖励，由 service_daily_bonus_limit_sale 字段进行时间段的选择
   */
  dailyCoinsReward: (service: any) => {
    if (!service) {
      return 0;
    }
    if (!VipOfferUtils.isDailyBonusVaild()) {
      return 0;
    }
    if (!service.hasOwnProperty("daily_bonus_info")) {
      return 0;
    }

    let coins = 0;

    const keys =
      service.free_days && service.free_days > 0
        ? ["is_trial", "is_not_trial"]
        : ["is_not_trial"];
    const bonusInfo: any = service.daily_bonus_info;
    keys.forEach((key: string) => {
      if (bonusInfo.hasOwnProperty(key) && Array.isArray(bonusInfo[key])) {
        bonusInfo[key].forEach((dict: any) => {
          if (dict.hasOwnProperty("bonus") && Array.isArray(dict.bonus)) {
            dict.bonus.forEach((item: any) => {
              if (item.type && item.effect) {
                if (item.type === "coin") {
                  coins += item.effect;
                }
              }
            });
          }
        });
      }
    });
    return coins;
  },

  isDailyBonusVaild: () => {
    const limitSale = VipOfferUtils.serviceDailyBonusLimitSale();
    if (!limitSale) {
      return false;
    }
    const now = new Date().valueOf();
    if (limitSale.start_time <= now && now <= limitSale.end_time) {
      return true;
    }
    return false;
  },
  /**
   * 获取servers 的limit sale
   */
  serviceDailyBonusLimitSale: () => {
    const limitSale =
      store.getters[types.GETTER_CLIENT_SETTINGS] &&
      store.getters[types.GETTER_CLIENT_SETTINGS].sale &&
      store.getters[types.GETTER_CLIENT_SETTINGS].sale
        .service_daily_bonus_limit_sale;
    if (
      limitSale &&
      limitSale.hasOwnProperty("start_time") &&
      limitSale.hasOwnProperty("end_time")
    ) {
      return limitSale;
    } else {
      return undefined;
    }
  }
};
export default VipOfferUtils;
